window.jQuery = window.$ = require('jquery');
var Parsley = require('parsleyjs');

(function(window, document, $) {

  $(document).ready(function() {

    // Require selected State
    window.ParsleyValidator
      .addValidator('cantbe',
        function(value, requirement) {
          return value != requirement;
        }, 32)
      .addMessage('en', 'cantbe', 'You must select a State.');

    // Require valid payment amount
    window.ParsleyValidator
      .addValidator('currency',
        function(value, requirement) {
          var paymentRegExp = /^\s*-?[1-9]\d*(\.\d{1,2})?\s*$/;
          return paymentRegExp.test(value);
        }, 32)
      .addMessage('en', 'currency', 'Please enter a valid payment amount.');

    // Change default 'required' message
    window.ParsleyValidator
      .addMessage('en', 'required', 'This field is required.');

    // Show "Submitting Registration" after submit button is clicked
    window.Parsley.on('form:submit', function() {
      $('#submit-registration').html('<img class="loading-img" src="/assets/images/loading.gif" alt="Loading..."> Processing...').attr('disabled', 'disabled');
    });
    
    // if there are payment notices
    if ($('#payment_notices').length) {
      $('html, body').animate({
        scrollTop: $("#payment_notices").offset().top - 30
      }, 700);
    }

    // If the registration form exists
    if ($('form.registration').length) {
      // Initialize Parsley (form validation)
      var registrationForm = $('form.registration').parsley();

      // update submit button text when billing_amount changes
      $('input#billing_amount').on('input', function() {
        if (registrationForm.isValid('paymentAmount')) {
          $('span.payment_amount').html('&amp; Pay $'+$(this).val()+'');
        } else {
          $('span.payment_amount').html('');
        }
      });

      // get initial cost and down payment values
      var initialCourseCost = Number($('form.registration').data('course-cost'));
      var initialCourseDownPayment = Number($('form.registration').data('course-down-payment'));

      var courseCost = initialCourseCost;
      var courseDownPayment = initialCourseDownPayment;

      // if the 'mail texts' checkbox exists...
      if ($('input#mail_texts').length) {
        // when the 'mail texts' checkbox changes...
        $('input#mail_texts').change(function() {
          var checked = $(this).is(":checked");
          var costChange = $(this).data('cost-change');

          // Change the cost and downpayment values appropriately
          if (checked) {
            courseCost += costChange;
            courseDownPayment += costChange;
          } else {
            courseCost -= costChange;
            courseDownPayment -= costChange;
          }
          // update relevant page elements with new cost and down payment values...
          // Top price display
          if (checked) {
            // show the new line item
            $('.course-info__cost').after('<p class="cost-line-item" id="mail_texts_cost">+ $'+costChange+' (cost to mail texts)</p>');
          } else {
            // remove the line item
            $('#mail_texts_cost').remove();
          }
          // placeholder of billing_amount field
          $('#billing_amount').attr('placeholder', courseDownPayment.toFixed(2) + ' - ' + courseCost.toFixed(2));
          // Explanation of billing_amount field
          $('span.course_down_payment').html(courseDownPayment.toFixed(2));
          $('span.course_cost').html(courseCost.toFixed(2));
          // validation settings of billing_amount field
          $('#billing_amount').attr('data-parsley-min', courseDownPayment);
          $('#billing_amount').attr('data-parsley-max', courseCost);
          // value of read-only billing_amount field
          if ( $('#billing_amount').is('[readonly]') ) {
            $('#billing_amount').val(courseCost.toFixed(2));
          }
          // Submit/Pay button text
          if ($('span.payment_amount').html().length) {
            $('span.payment_amount').html('&amp; Pay $'+$('#billing_amount').val()+'');
          } else {
            $('span.payment_amount').html('');
          }

          // Re-validate billing amount
          if (!$('#billing_amount').is('[readonly]') && $('span.payment_amount').html().length) {
            registrationForm.validate('paymentAmount');
          }
        });
      }

      // if the 'aerie alum' checkbox exists...
      if ($('input#aerie_alum').length) {
        // when the 'mail texts' checkbox changes...
        $('input#aerie_alum').change(function() {
          var checked = $(this).is(":checked");
          var costChange = $(this).data('cost-change');

          // Change the cost and downpayment values appropriately
          if (checked) {
            courseCost += costChange;
            courseDownPayment += costChange;
          } else {
            courseCost -= costChange;
            courseDownPayment -= costChange;
          }
          // update relevant page elements with new cost and down payment values...
          // Top price display
          if (checked) {
            // show the new line item
            $('.course-info__cost').after('<p class="cost-line-item" id="aerie_alum_discount">- $'+Math.abs(costChange)+' (Aerie alum discount)</p>');
          } else {
            // remove the line item
            $('#aerie_alum_discount').remove();
          }
          // placeholder of billing_amount field
          $('#billing_amount').attr('placeholder', courseDownPayment.toFixed(2) + ' - ' + courseCost.toFixed(2));
          // Explanation of billing_amount field
          $('span.course_down_payment').html(courseDownPayment.toFixed(2));
          $('span.course_cost').html(courseCost.toFixed(2));
          // validation settings of billing_amount field
          $('#billing_amount').attr('data-parsley-min', courseDownPayment);
          $('#billing_amount').attr('data-parsley-max', courseCost);
          // value of read-only billing_amount field
          if ( $('#billing_amount').is('[readonly]') ) {
            $('#billing_amount').val(courseCost.toFixed(2));
          }
          // Submit/Pay button text
          if ($('span.payment_amount').html().length) {
            $('span.payment_amount').html('&amp; Pay $'+$('#billing_amount').val()+'');
          } else {
            $('span.payment_amount').html('');
          }

          // Re-validate billing amount
          if (!$('#billing_amount').is('[readonly]') && $('span.payment_amount').html().length) {
            registrationForm.validate('paymentAmount');
          }
        });
      }

    } // end of 'if form.registration'

    // If the registration payment form exists
    if ($('form.registration-payment').length) {
      var registrationPaymentForm = $('form.registration-payment').parsley();
    }

  });

}(window, window.document, window.jQuery)); // Fully reference jQuery after this point.



/** WEBPACK FOOTER **
 ** ./js/registration.js
 **/